import { useQuery } from "@tanstack/react-query";
import { Link } from "wouter";
import { DataTable, EmptyState, Loader } from "@threadws/jute";
import { agentsListOptions } from "../../api/generated/@tanstack/react-query.gen";
import { formatDate } from "../../utils/formatDate";

const columns = [
  { key: "name", label: "Agent" },
  { key: "version", label: "Active version" },
  { key: "updated", label: "Updated" },
];

/** Sage's agents. Each is created by the code that uses it; here you change their prompts. */
export function AgentsListPage() {
  const { data: agents, error } = useQuery(agentsListOptions());

  if (error) return <EmptyState title="Couldn't load agents" description={error.message} />;
  if (!agents) return <Loader label="Loading agents" />;

  const rows = agents.map((agent) => ({
    id: agent.id,
    name: (
      <div className="flex flex-col gap-0.5">
        <Link href={`/agents/${agent.id}`} className="text-text-link hover:text-text-link-hover">
          {agent.name}
        </Link>
        <span className="text-xs text-text-secondary">{agent.description}</span>
      </div>
    ),
    version: (
      <span className="font-mono text-xs">
        v{agent.activeVersion.version} · {agent.activeVersion.model}
      </span>
    ),
    updated: formatDate(agent.updatedAt),
  }));

  return (
    <section className="flex w-full max-w-3xl flex-col gap-6 px-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-2xl font-medium">Agents</h1>
        <p className="text-sm text-text-secondary">
          Each agent's prompt and model. Saving an edit adds a version, so you can always go back.
        </p>
      </header>
      {agents.length === 0 ? (
        <EmptyState title="No agents yet" description="Agents appear here once the API has started with them." />
      ) : (
        <DataTable columns={columns} rows={rows} />
      )}
    </section>
  );
}
